import './css/styles.css';
import { createDOMController } from './modules/dom.js';

const domController = createDOMController();
domController.initialize();
